var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgSelfieCapture = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M33.18 39.468c0 8.119 6.644 14.71 14.793 14.71 8.148 0 14.776-6.608 14.793-14.71v-8.399c0-8.119-6.645-14.71-14.793-14.71-8.165 0-14.793 6.591-14.793 14.71v8.399Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M37.532 40.976c0 6.746 5.34 12.221 11.888 12.221s11.875-5.489 11.888-12.221v-6.978c0-6.746-5.34-12.222-11.888-12.222-6.562 0-11.888 5.476-11.888 12.222v6.978Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M61.938 40.021c0 4.316-1.421 7.712-3.848 10.032-2.43 2.323-5.945 3.636-10.256 3.636-4.312 0-7.773-1.312-10.152-3.631-2.377-2.317-3.753-5.713-3.753-10.037 0-1.036-.049-2.655-.098-4.276l-.002-.075c-.05-1.657-.1-3.308-.1-4.387 0-9.11 7.563-14.104 14.105-14.104 6.54 0 14.104 4.995 14.104 14.104v8.738Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M22.311 80.82C27.881 83.745 37.504 87 47.835 87c10.33 0 20.247-3.255 25.817-6.18a6.054 6.054 0 0 0 3.256-5.03c.463-7.543-2.066-11.406-4.28-13.312-1.059-.92-2.414-1.578-4.116-1.989-5.785-1.38-11.437-5.544-11.503-5.61-6.116 3.489-12.67 3.052-18.786-.006-7.864 5.243-6.781 4.664-10.771 5.616-1.703.411-3.058 1.069-4.116 1.989-2.215 1.906-4.743 5.769-4.28 13.312a6.055 6.055 0 0 0 3.255 5.03Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M38.223 54.873c-.066.066-4.986 4.23-10.771 5.61-1.703.41-3.058 1.068-4.116 1.988-2.215 1.907-4.743 5.77-4.28 13.313.132 2.137 1.522 4.3 3.44 5.302 5.57 2.925 15.008 5.907 25.339 5.907 10.33 0 20.206-2.982 25.776-5.907 1.917-1.003 3.165-3.165 3.297-5.302.463-7.544-2.066-11.406-4.28-13.313-1.059-.92-2.414-1.577-4.116-1.988-5.785-1.38-11.437-5.544-11.503-5.61"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M52.183 81.136c5.423 0 11.45-1.165 17.475-5.243"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36.095 9a2.038 2.038 0 0 1 0 4.075h-8.151a3.396 3.396 0 0 0-3.396 3.397v8.15a2.038 2.038 0 0 1-4.076 0v-8.15A7.472 7.472 0 0 1 27.944 9h8.15Zm38.83 15.623a2.038 2.038 0 0 1-4.076 0v-8.151a3.396 3.396 0 0 0-3.396-3.397h-8.15a2.038 2.038 0 1 1 0-4.075h8.15a7.472 7.472 0 0 1 7.472 7.472v8.15ZM59.302 60.51a2.038 2.038 0 0 1 0-4.075h8.151a3.396 3.396 0 0 0 3.396-3.396v-8.151a2.038 2.038 0 1 1 4.076 0v8.15a7.472 7.472 0 0 1-7.472 7.472h-8.15Zm-38.83-15.622a2.038 2.038 0 1 1 4.075 0v8.15a3.396 3.396 0 0 0 3.397 3.397h8.15a2.038 2.038 0 1 1 0 4.075h-8.15a7.472 7.472 0 0 1-7.472-7.471v-8.151Z",
    clipRule: "evenodd"
  }));
};
export default SvgSelfieCapture;